import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { StackingAlertBanner } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { certsListExportStatus } from '../../../../redux/certlist/action';
import { getMessageKey } from '../../../../utils/utils';

function CertsExportAlert({ exportStatus }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [alertStatus, setAlertStatus] = useState('');

  const { messages } = useSelector((state) => state?.user);

  useEffect(() => {
    const currentExportStatus = exportStatus?.exportStatus;

    switch (currentExportStatus) {
      case 'SUCCESS':
      case 'FAILED-412':
        setAlertStatus(currentExportStatus);
        break;

      case 'FAILED':
        // if neoExport is false show Alert Banner
        if (!exportStatus?.neoExport) {
          setAlertStatus(currentExportStatus);
        }

        break;
      default:
        setAlertStatus('');
        break;
    }
  }, [exportStatus]);

  const alertConfigs = {
    SUCCESS: {
      colorTheme: 'Information',
      title:
        messages.EXPORT_ALERT_SUCCESS_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_SUCCESS_TITLE')),
      description:
        messages['EXPORT_ALERT_SUCCESS_DESCRIPION.ATTESTATIONS'] ||
        localize(
          intl,
          getMessageKey('EXPORT_ALERT_SUCCESS_DESCRIPION.ATTESTATIONS')
        ),
    },
    FAILED: {
      colorTheme: 'Critical',
      title:
        messages.EXPORT_ALERT_FAILED_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_FAILED_TITLE')),
      description:
        messages['EXPORT_ALERT_FAILED_DESCRIPION.ATTESTATIONS'] ||
        localize(
          intl,
          getMessageKey('EXPORT_ALERT_FAILED_DESCRIPION.ATTESTATIONS')
        ),
    },
    'FAILED-412': {
      colorTheme: 'Information',
      title:
        messages.EXPORT_ALERT_FAILED412_TITLE ||
        localize(intl, getMessageKey('EXPORT_ALERT_FAILED412_TITLE')),
      description:
        messages['EXPORT_ALERT_FAILED412_DESCRIPTION.ATTESTATIONS'] ||
        localize(
          intl,
          getMessageKey('EXPORT_ALERT_FAILED412_DESCRIPTION.ATTESTATIONS')
        ),
    },
  };

  const config = alertConfigs[alertStatus];

  return config ? (
    <StackingAlertBanner
      colorTheme={config.colorTheme}
      title={config.title}
      description={config.description}
      isVisible={config}
      kind='low'
      onCancel={() => {
        setAlertStatus('');
        dispatch(
          certsListExportStatus({
            exportStatus: '',
            timeStamp: Date.now(),
            neoExport: false,
          })
        );
      }}
      shouldAutoDismiss
    />
  ) : null;
}

CertsExportAlert.propTypes = {
  exportStatus: PropTypes.shape({
    exportStatus: PropTypes.string,
    neoExport: PropTypes.bool,
  }).isRequired,
};

export default CertsExportAlert;
